import { createFileRoute, useRouter } from "@tanstack/react-router";
import { z } from "zod";
import { AuthCard } from "@/components/auth-card";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { StaffSignInForm } from "@/features/staff/sign-in/form";
import { m } from "@/lib/paraglide/messages.js";

const StaffLoginSearch = z.object({
  // Where to go after sign-in: a staff path only, never another site (an open redirect).
  redirect: z
    .string()
    .regex(/^\/staff(\/|$)/)
    .optional()
    .catch(undefined),
  // ?password=set: the set-password page sent them here.
  password: z.literal("set").optional().catch(undefined),
});

export const Route = createFileRoute("/staff/login")({
  validateSearch: StaffLoginSearch,
  component: StaffLoginPage,
});

function StaffLoginPage() {
  const { redirect, password } = Route.useSearch();
  const router = useRouter();
  return (
    <AuthCard title={m.staff_sign_in_title()} area="staff">
      {password && (
        <Alert>
          <AlertDescription>{m.staff_sign_in_password_saved()}</AlertDescription>
        </Alert>
      )}
      <StaffSignInForm
        onSignedIn={() => router.history.push(redirect ?? "/staff")}
        onNeedsEnrolment={() => router.navigate({ to: "/staff/enrol" })}
      />
    </AuthCard>
  );
}
